import React from 'react';
import './sceneName.scss';

export default ({ scene }) => {
  const { title } = scene;

  return (
    <div className="vgp-scene-name">
      <span>{title}</span>
    </div>
  );
};
